import { Injectable } from '@angular/core';
import { Response, URLSearchParams } from '@angular/http';
import { Angular2TokenService } from 'angular2-token';
import { AppState } from "@store/app-state";
import { Observable } from 'rxjs';
import { Template } from "@models/template";
import { Recipient } from "@models/recipient";
import { CommSend } from "@models/comm-send";
import { CommReceipt } from "@models/comm-receipt";

export interface SendCommParams {
  edited_template_body?: string,
  termId: number,
  templateId: number,
  sendTo: number,
  recipients: Recipient[],
  enquiryId?: number,
  enquirySendTo?: string,
}

export interface CommReceiptsIndexParams {
  comm_send_id: number,
}

export interface FetchCommSendsParams {
  type_of: number,
}

export interface EmailPreviewParams {
  term_id: number,
  template_id: number,
  contact_id?: number,
  course_id?: number,
  matrix_class_id?: number,
  grade?: number,
  edited_template_body?: string,
}

export interface NumberOfRecipientsParams {
  recipients: Recipient[],
  template_id: number,
}

export const commsUrl: string = "communications"
export const templatesUrl: string = "templates"

@Injectable()
export class CommService {

  constructor(
    private http: Angular2TokenService,
  ) {}

  templatesIndex(): Observable<Template[]> {
    return this.http.get(`${templatesUrl}?external=true`)
      .map((res: Response) => res.json().map((t: any) => Template.clone(t)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  commSendsIndex(params: FetchCommSendsParams): Observable<CommSend[]> {
    const search: URLSearchParams = new URLSearchParams()
    for (let key in params) { search.set(key, params[key]) }

    return this.http.get(`${commsUrl}/comm_sends`, { search })
      .map((res: Response) => res.json().map((cs: any) => CommSend.clone(cs)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  commReceiptsIndex(params: CommReceiptsIndexParams): Observable<CommReceipt[]> {
    const search: URLSearchParams = new URLSearchParams()
    for (let key in params) { search.set(key, params[key]) }

    return this.http.get(`${commsUrl}/comm_receipts`, { search })
      .map((res: Response) => res.json().map((cr: any) => CommReceipt.clone(cr)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  emailPreview(params: EmailPreviewParams): Observable<string> {
    return this.http.patch(`${commsUrl}/email_preview`, params)
      .map((res: Response) => res.json().html)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  numberOfRecipients(params: NumberOfRecipientsParams): Observable<number> {
    return this.http.patch(`${commsUrl}/number_of_recipients`, params)
      .map((res: Response) => res.json().count)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  reloadEmailTemplates(): Observable<boolean> {
    return this.http.patch(`${templatesUrl}/reload_email_templates`, {})
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

  sendComm(payload: SendCommParams): Observable<boolean> {
    return this.http.post(`${commsUrl}/send_comm`, payload)
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }
  
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/comm.ts